import React, { Component } from 'react';
import { PropTypes } from 'prop-types';

import { GridHelper } from '../GridHelper';

export default class PagingButtons extends Component {
  static propTypes = {
    pageNumber: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    totalItems: PropTypes.number.isRequired,
    changePageCallback: PropTypes.func.isRequired
  };

  static defaultProps = {
    /*     pageNumber: 1,
    pageSize: 50,
    totalItems: 0 */
  };

  constructor(props) {
    super(props);

    this.state = {
      pageNumber: props.pageNumber,
      currentPageSize: props.pageSize
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.pageNumber !== state.pageNumber) {
      return {
        pageNumber: props.pageNumber
      };
    }
    return null;
  }

  shouldComponentUpdate(nextProps, nextState) {
    const {
      pageSize,
      totalItems,
    } = this.props;
    const {
      pageNumber,
      currentPageSize
    } = this.state;
    return !(
      pageSize === nextProps.pageSize
      && totalItems === nextProps.totalItems
      && pageNumber === nextProps.pageNumber
      && pageNumber === nextState.pageNumber
      && currentPageSize === nextState.currentPageSize
    );
  }

  updatePageSize(evt) {
    const { changePageCallback, totalItems } = this.props;
    let { pageNumber } = this.state;

    const pageSize = Number(evt.target.value);

    if (pageNumber > 1) {
      if (((pageNumber - 1) * pageSize) > totalItems) {
        pageNumber = parseInt(totalItems / pageSize, 10) + 1;
      }
    }

    this.setState({ currentPageSize: pageSize, pageNumber });
    changePageCallback(
      {
        number: pageNumber,
        size: pageSize
      }
    );
  }

  resetPageNumber(page) {
    this.setState({ pageNumber: page });
  }

  isPagingButtonEnabled(navigation) {
    const {
      totalItems,
      pageSize
    } = this.props;
    const { pageNumber } = this.state;

    if (
      totalItems === 0
      || pageSize === 0
    ) {
      return false;
    }

    const remainder = totalItems % pageSize;
    const pageCount = Math.trunc(totalItems / pageSize) + ((remainder > 0) ? 1 : 0);

    const nav = GridHelper.pageNavigationSteps;

    switch (navigation) {
      case nav.first:
        return pageNumber > 1;
      case nav.last:
        return pageNumber !== 0 && pageNumber !== pageCount;
      case nav.next:
        return pageNumber >= 1 && pageNumber < pageCount;
      case nav.previous:
        return pageNumber > 1 && pageNumber <= pageCount;
      default:
        return false;
    }
  }

  changePage(navigation) {
    const {
      totalItems,
      changePageCallback
    } = this.props;
    const {
      pageNumber,
      currentPageSize
    } = this.state;

    if (
      totalItems === 0
      || currentPageSize === 0
      || pageNumber === 0
    ) {
      return;
    }

    const nav = GridHelper.pageNavigationSteps;

    const remainder = totalItems % currentPageSize;
    const pageCount = Math.trunc(totalItems / currentPageSize) + ((remainder > 0) ? 1 : 0);
    let newPageNumber = pageNumber;

    switch (navigation) {
      case nav.first:
        newPageNumber = 1;
        break;
      case nav.last:
        newPageNumber = pageCount;
        break;
      case nav.next:
        newPageNumber = pageNumber + 1;
        break;
      case nav.previous:
        newPageNumber = pageNumber - 1;
        break;
      default:
        break;
    }

    if (
      changePageCallback
      && changePageCallback(
        {
          number: newPageNumber,
          size: currentPageSize
        }
      )
    ) {
      this.setState({ pageNumber: newPageNumber });
    }
  }

  nextPage() {
    this.changePage(GridHelper.pageNavigationSteps.next);
  }

  lastPage() {
    this.changePage(GridHelper.pageNavigationSteps.last);
  }

  firstPage() {
    this.changePage(GridHelper.pageNavigationSteps.first);
  }

  previousPage() {
    this.changePage(GridHelper.pageNavigationSteps.previous);
  }

  render() {
    const {
      pageSize,
      totalItems
    } = this.props;

    const {
      currentPageSize
    } = this.state;

    let {
      pageNumber
    } = this.state;

    const nav = GridHelper.pageNavigationSteps;

    const remainder = totalItems % pageSize;
    const pageCount = Math.trunc(totalItems / pageSize) + ((remainder > 0) ? 1 : 0);

    let pageFirstRowNum = 0;
    let pageLastRowNum = 0;

    if (totalItems !== 0) {
      if (
        pageNumber === 0
        && totalItems > 0
      ) {
        pageNumber = 1;
      }
      pageFirstRowNum = (pageNumber !== 0) ? (pageNumber * pageSize) - (pageSize - 1) : 0;
      pageLastRowNum = pageCount !== pageNumber ? pageNumber * pageSize : totalItems;
    } else {
      pageNumber = 0;
    }

    const firstEnabled = this.isPagingButtonEnabled(nav.first);
    const lastEnabled = this.isPagingButtonEnabled(nav.last);
    const nextEnabled = this.isPagingButtonEnabled(nav.next);
    const previousEnabled = this.isPagingButtonEnabled(nav.previous);

    return (
      <div className="ag-paging-panel ag-font-style">
        <span id="eSummaryPanel" className="ag-paging-row-summary-panel">
          <span id="lbFirstRowOnPage">{ pageFirstRowNum }</span> to <span id="lbLastRowOnPage">{ pageLastRowNum }</span> of <span id="lbRecordCount">{ totalItems }</span>
        </span>
        <span className="ag-paging-page-summary-panel">
          <button type="button" className="btn ag-paging-button" id="btFirst" disabled={ !firstEnabled } onClick={ () => this.firstPage() }>First</button>
          <button type="button" className="btn ag-paging-button" id="btPrevious" disabled={ !previousEnabled } onClick={ () => this.previousPage() }>Previous</button>
          Page <span id="lbCurrent">{ pageNumber }</span> of <span id="lbTotal">{ pageCount }</span>
          <button type="button" className="btn ag-paging-button" id="btNext" disabled={ !nextEnabled } onClick={ () => this.nextPage() }>Next</button>
          <button type="button" className="btn ag-paging-button" id="btLast" disabled={ !lastEnabled } onClick={ () => this.lastPage() }>Last</button>
        </span>
        <span id="ePageSize" className="ag-page-size">
          <select id="pageSize" className="form-select" value={ currentPageSize } onChange={ e => this.updatePageSize(e) }>
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </span>
      </div>
    );
  }
}
